module.exports = __webpack_public_path__ + "img/loading_legacy.6f6880c8.gif";